import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import Select from "react-select";


function Add(props) {
  const [categoryList, setCategoryList] = useState([]);
  const [subCatList, setSubCatList] = useState([]);
  const [units, setUnits] = useState([]);
  const [isEdit, setisEdit] = useState(false);
  const [formData, setFormData] = useState({
    category: "",
    sub_category: "",
    brand_name: "",
    product_name: "",
    product_code: "",
    units: "",
    cas_no: "",
    lead_time: "",
    HSN_code: "",
    qty: "",
  });
  const [isConsumable, setIsConsumable] = useState(false);
  const [stockAlert, setStockAlert] = useState({
    high: "",
    medium: "",
    low: "",
  });
  const [isActive, setIsActive] = useState("");

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [category, setCategory] = useState(null);
  const [Subcategory, setSubCategory] = useState(null);
  const [unit, setUnit] = useState("");
  const [calculatedValue, setCalculatedValue] = useState("");
  const [validateMobile, setValidateMobile] = useState(false);

  const statusList = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];

  useEffect(() => {
    getCat();
    getUnits();
  }, []);

  const getCat = () => {
    utils
      .callAPI("get", `/rawmaterial/category/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredCategories = res?.result?.filter(
            (category) => category.status === "1"
          );
          setCategoryList(filteredCategories);
        } else {
          setCategoryList([]);
        }
      })
      .catch((err) => {
        setCategoryList([]);
      });
  };

  const getUnits = () => {
    utils
      .callAPI("get", `/unit/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredUnits = res?.result?.filter(
            (category) => category.status === "1"
          );
          setUnits(filteredUnits);
        } else {
          setUnits([]);
        }
      })
      .catch((err) => {
        setUnits([]);
      });
  };

  const handleCat = (selectedOption) => {
    setCategory(selectedOption);
    getSubCategory(selectedOption.value);
  };

  const getSubCategory = (CatId) => {
    utils
      .callAPI("get", `/rawmaterial/subcategory/listById?categoryId=${CatId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredCategories = res?.filter(
            (category) => category.status === "1"
          );

          setSubCatList(filteredCategories);
        } else {
          setSubCatList([]);
        }
      })
      .catch((err) => {
        setSubCatList([]);
      });
  };
  const handleSubCat = (selectedOption) => {
    setSubCategory(selectedOption);
  };

  const handleUnit = (event) => {
    setUnit(event.target.value);
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      if (validateMobile) {
        return;
      }
      console.log(formData);
      console.log(stockAlert);
      setIsSubmit(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const validatedValue = value.replace(/\D/g, "");

    setFormData({
      ...formData,
      [name]: name === "qty" || name === "lead_time" ? validatedValue : value,
    });
  };

  const handleQy = (e) => {
    const { name, value } = e.target;
    const selectedUnit = units.find((units) => units.id === unit);
    if (selectedUnit?.name == "Liter") {
      const calculated = value * 0.9;
      setCalculatedValue(calculated);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    const validatedValue = value.replace(/\D/g, "");

    setStockAlert((prevState) => ({
      ...prevState,
      [name]: validatedValue,
    }));
  };

  useEffect(() => {
    if (isSubmit) {
      const stockAlertArray = [
        { unit: stockAlert.high, priority: "High" },
        { unit: stockAlert.medium, priority: "Medium" },
        { unit: stockAlert.low, priority: "Low" },
      ];
      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append("category_id", category?.value);
      bodyFormData.append("subcategory_id", Subcategory?.value);
      bodyFormData.append("brand_name", formData.brand_name);
      bodyFormData.append("product_name", formData.product_name);
      bodyFormData.append("product_code", formData.product_code);
      bodyFormData.append("unit_id", unit);
      // bodyFormData.append("qty", formData.qty);
      // bodyFormData.append("in_kg", 0);
      bodyFormData.append("cas_no", formData.cas_no);
      bodyFormData.append("lead_time", formData.lead_time);
      bodyFormData.append("hsn_code", formData.HSN_code);
      bodyFormData.append("status", isActive);
      bodyFormData.append("isconsumable", isConsumable ? "yes" : "no");
      bodyFormData.append("stock_alert", JSON.stringify(stockAlertArray));

      utils
        .callAPI("post", `/rawmaterial/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setCategory({
        label: props.rowData?.category_name,
        value: props.rowData?.category_id,
      });
      if (props?.rowData?.category_id) {
        getSubCategory(props?.rowData?.category_id);
      }
      setSubCategory({
        value: props?.rowData?.subcategory_id,
        label: props?.rowData?.subcategory_name,
      });
      setFormData({
        brand_name: props?.rowData?.brand_name,
        product_name: props?.rowData?.product_name,
        product_code: props?.rowData?.product_code,
        qty: props?.rowData?.qty,
        cas_no: props?.rowData?.cas_no,
        HSN_code: props?.rowData?.hsn_code,
        lead_time: props?.rowData?.lead_time,
      });
      setIsConsumable(props?.rowData?.isconsumable == "yes" ? true : false);
      setUnit(props?.rowData?.unit_id);
      setIsActive(props.rowData.status);
      const stockAlertData = props?.rowData?.stock_alert;

      const newStockAlert = {
        high: "",
        medium: "",
        low: "",
      };

      stockAlertData.forEach((alert) => {
        if (alert.priority === "High") {
          newStockAlert.high = alert.unit;
        } else if (alert.priority === "Medium") {
          newStockAlert.medium = alert.unit;
        } else if (alert.priority === "Low") {
          newStockAlert.low = alert.unit;
        }
      });

      setStockAlert(newStockAlert);
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const handleStatusChange = (event) => {
    setIsActive(event.target.value);
  };

  const handleConsumableChange = (event) => {
    setIsConsumable(event.target.checked);
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header className="border-0">
          <h4>{isEdit ? "Edit" : "Add"}</h4>

          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="mb-1">
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <Select
                      id="category"
                      name="category"
                      options={categoryList.map((cat) => ({
                        value: cat.id,
                        label: cat.category_name,
                      }))}
                      value={category || null}
                      onChange={handleCat}
                      placeholder="Select Category..."
                      isSearchable
                      styles={customStyles}
                    />
                    {validated && !category && (
                      <div className="invalid-feedback d-block">
                        Please select category.
                      </div>
                    )}
                  </div>
                </RB.Col>

                <RB.Col md={6}>
                  <div className="mb-3">
                    <Select
                      id="category"
                      name="subcategory"
                      options={subCatList.map((cat) => ({
                        value: cat.id,
                        label: cat.subcategory_name,
                      }))}
                      value={Subcategory || null}
                      onChange={handleSubCat}
                      placeholder="Select Sub Category..."
                      isSearchable
                      styles={customStyles}
                    />
                    {validated && !Subcategory && (
                      <div className="invalid-feedback d-block">
                        Please select Sub Category.
                      </div>
                    )}
                  </div>
                </RB.Col>

                <h6 className="mt-2">Basic Information</h6>
                <hr className="hr-lg mt-1" />
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Brand Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Brand Name"
                        name="brand_name"
                        value={formData.brand_name}
                        onChange={handleInputChange}
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter Brand Name.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Product Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Product Name"
                        name="product_name"
                        value={formData.product_name}
                        onChange={handleInputChange}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter Product Name.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Product Code"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Product Code"
                        name="product_code"
                        value={formData.product_code}
                        onChange={handleInputChange}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter Product Code.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="Unit"
                      label="Unit"
                      name="units"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={unit}
                        onChange={handleUnit}
                        required
                      >
                        <option value="">Select Unit...</option>
                        {units?.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.name}
                          </option>
                        ))}
                      </RB.Form.Select>
                      <RB.Form.Control.Feedback type="invalid">
                        Please select Unit.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                {/* <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Quantity"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Quantity"
                        name="qty"
                        value={formData.qty}
                        onChange={handleQy}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter Quantity.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                  {calculatedValue}
                </RB.Col> */}

                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="CAS No."
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter CAS No."
                        name="cas_no"
                        value={formData.cas_no}
                        onChange={handleInputChange}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter CAS No.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Lead Time(In Days)"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Lead Time(In Days)"
                        name="lead_time"
                        value={formData.lead_time}
                        onChange={handleInputChange}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter Lead Time.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="HSN Code"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter HSN Code"
                        name="HSN_code"
                        value={formData.HSN_code}
                        onChange={handleInputChange}
                        required
                      />
                      <RB.Form.Control.Feedback type="invalid">
                        Please Enter HSN Code.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={4}>
                  <div className="mt-4 d-flex align-items-center">
                    <RB.Form.Check
                      type="checkbox"
                      id="isConsumable"
                      label="Is Consumable"
                      checked={isConsumable}
                      onChange={handleConsumableChange}
                      className="form-check-lg me-2"
                    />
                  </div>
                </RB.Col>

                <RB.Col md={4}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="isActive"
                      label="Status"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={isActive}
                        onChange={handleStatusChange}
                        required
                      >
                        {statusList.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.name}
                          </option>
                        ))}
                      </RB.Form.Select>
                      <RB.Form.Control.Feedback type="invalid">
                        Please select status.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
              <RB.Row>
                <h6 className="mt-2">Stock Alert</h6>
                <hr className="hr-lg mt-1" />
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="High"
                    defaultValue="High"
                    readOnly
                  />
                </RB.Col>
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="Enter quantity"
                    name="high"
                    value={stockAlert.high}
                    onChange={handleChange}
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter quantity.
                  </RB.Form.Control.Feedback>
                </RB.Col>
              </RB.Row>

              <RB.Row className="mt-2">
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="Medium"
                    defaultValue="Medium"
                    readOnly
                  />
                </RB.Col>
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="Enter quantity"
                    name="medium"
                    value={stockAlert.medium}
                    onChange={handleChange}
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter quantity.
                  </RB.Form.Control.Feedback>
                </RB.Col>
              </RB.Row>

              <RB.Row className="mt-2">
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="Low"
                    defaultValue="Low"
                    readOnly
                  />
                </RB.Col>
                <RB.Col md={4}>
                  <RB.Form.Control
                    required
                    type="text"
                    placeholder="Enter quantity"
                    name="low"
                    value={stockAlert.low}
                    onChange={handleChange}
                  />
                  <RB.Form.Control.Feedback type="invalid">
                    Please enter quantity.
                  </RB.Form.Control.Feedback>
                </RB.Col>
              </RB.Row>
            </div>

            {/* <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formRoleId"
                    label="Role"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      as="select"
                      name="roleId"
                      value={formData.roleId}
                      onChange={handleInputChange}
                      required
                    >
                      {role.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.roleName}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row> */}

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
